<template>
    <div>        
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 gallery-hero d-flex  align-items-end">
                    <div class="container">
                        <div class="row">
                            <h1 class="hero-heading">GALLERY</h1>
                        </div>
                    </div>
                    <!-- <Navigation /> -->
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <!-- <div class="row my-5">
                <div class="col-12 text-center">
                    <h3 class="heading">2013</h3>
                    <hr class="custom-hr" />
                </div>
            </div> -->
            <div style="position:fixed; left:0; bottom:0; background:pink; z-index:666;font-size:5rem;">

            <!-- {{ index }} -->
            </div>
            <!-- {{ galleryLength }} -->
            <!-- <div class="row">
                <div class="col-12">
                    <p class="years">2013</p>
                </div>
            </div> -->
            <div class="row">
                <div class="col-12 d-flex justify-content-center">
                    <!-- <vue-gallery :images="images" :index="index" @close="index = null"></vue-gallery> -->
                    <div class="mt-5 gallery-wrapper" >
                        <div v-for="(gallery, galleryIndex) in galleries" :key="gallery.year">
                            <div class="col-12 text-center my-5">
                                <h3 class="heading">{{ gallery.year }}</h3>
                                <hr class="custom-hr" />
                            </div>
                            <!-- {{ gallery.images }} -->
                            <!-- <div
                                class="image"
                                v-for="(image, imageIndex) in gallery.images"   
                                :key="getIndex(imageIndex, galleryIndex)"
                                @click="index = getIndex(imageIndex, galleryIndex)"
                                :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
                            >
                            </div> -->
                            <div class="row">
                                <div class="col-12">
                                    <silentbox-group class="display:flex; flex-wrap: wrap">
                                        <div v-for="(image,index) in gallery.images" :key="image.index" class="image">
                                            <silentbox-item :src="image"  description="Metropolis Asia" style="height:100%">
                                                <img v-lazy="image" style="width:100%; height:100%">
                                            
                                            </silentbox-item>
                                        </div>
                                    </silentbox-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="mt-5 gallery-wrapper">
                        <div class="image" v-for="gallery in galleries" :key="gallery.year">
                        <vue-gallery :images="gallery.images" :index="index" @close="index = null"></vue-gallery>
                            <p>{{ gallery.year }}</p>
                            <div>
                                <div
                                    class="image"
                                    v-for="(image, imageIndex) in gallery.images"
                                    :key="imageIndex"
                                    @click="index = imageIndex"
                                    :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
                                ></div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>


<script>
// import VueGallery from 'vue-gallery';

// import { close } from 'fs';
export default {
    components:{
        // 'vue-gallery': VueGallery,
    },
    data(){
        return{
            // images: [require("../assets/images/galleries/metro13/2.jpg"),
            // require("../assets/images/galleries/metro13/3.jpg"),
            // require("../assets/images/galleries/metro13/4.jpg"),
            // ],
            galleries: [
                
                {year: "2020",images:[require("../assets/images/galleries/metro20/2.jpg"),
                                require("../assets/images/galleries/metro20/5.jpg"),
                                require("../assets/images/galleries/metro20/6.jpg"),
                                require("../assets/images/galleries/metro20/9.jpg"),
                                require("../assets/images/galleries/metro20/14.jpg"),
                                require("../assets/images/galleries/metro20/16.jpg"),
                                require("../assets/images/galleries/metro20/17.jpg"),
                                require("../assets/images/galleries/metro20/20.jpg"),
                                require("../assets/images/galleries/metro20/21.jpg"),]
                                
            },
                {year: "2018",images:[require("../assets/images/galleries/metro18/1.jpg"),
                                require("../assets/images/galleries/metro18/2.jpg"),
                                require("../assets/images/galleries/metro18/3.jpg"),
                                require("../assets/images/galleries/metro18/4.jpg"),
                                require("../assets/images/galleries/metro18/5.jpg"),
                                require("../assets/images/galleries/metro18/6.jpg"),
                                require("../assets/images/galleries/metro18/7.jpg"),]
                                
            },
                {year: "2017",images:[require("../assets/images/galleries/metro17/1.jpg"),
                                require("../assets/images/galleries/metro17/2.jpg"),
                                require("../assets/images/galleries/metro17/3.jpg"),
                                require("../assets/images/galleries/metro17/4.jpg"),
                                require("../assets/images/galleries/metro17/7.jpg"),
                                require("../assets/images/galleries/metro17/8.jpg"),
                                require("../assets/images/galleries/metro17/9.jpg"),
                                require("../assets/images/galleries/metro17/10.jpg"),]
            },
            {year: "2016",images:[require("../assets/images/galleries/metro16/1.jpg"),
                                require("../assets/images/galleries/metro16/2.jpg"),
                                require("../assets/images/galleries/metro16/3.jpg"),
                                require("../assets/images/galleries/metro16/4.jpg"),
                                require("../assets/images/galleries/metro16/5.jpg"),
                                require("../assets/images/galleries/metro16/6.jpg"),
                                require("../assets/images/galleries/metro16/7.jpg"),
                                require("../assets/images/galleries/metro16/8.jpg"),
                                require("../assets/images/galleries/metro16/9.jpg"),]
            },
             {year: "2015",images:[require("../assets/images/galleries/metro15/1.jpg"),
                                require("../assets/images/galleries/metro15/2.jpg"),
                                require("../assets/images/galleries/metro15/3.jpg"),
                                require("../assets/images/galleries/metro15/4.jpg"),
                                require("../assets/images/galleries/metro15/5.jpg"),
                                require("../assets/images/galleries/metro15/6.jpg"),
                                require("../assets/images/galleries/metro15/7.jpg"),
                                require("../assets/images/galleries/metro15/8.jpg"),
                                require("../assets/images/galleries/metro15/9.jpg"),]
            },
            {year: "2014",images:[require("../assets/images/galleries/metro14/1.jpg"),
                                require("../assets/images/galleries/metro14/2.jpg"),
                                require("../assets/images/galleries/metro14/3.jpg"),
                                require("../assets/images/galleries/metro14/4.jpg"),
                                require("../assets/images/galleries/metro14/5.jpg"),
                                require("../assets/images/galleries/metro14/6.jpg"),
                                require("../assets/images/galleries/metro14/7.jpg"),
                                require("../assets/images/galleries/metro14/8.jpg"),
                                require("../assets/images/galleries/metro14/9.jpg"),]
            },
                {year: "2013",images:[require("../assets/images/galleries/metro13/1.jpg"),
                                require("../assets/images/galleries/metro13/2.jpg"),
                                require("../assets/images/galleries/metro13/3.jpg"),
                                require("../assets/images/galleries/metro13/4.jpg"),
                                require("../assets/images/galleries/metro13/5.jpg"),
                                require("../assets/images/galleries/metro13/6.jpg"),
                                require("../assets/images/galleries/metro13/7.jpg"),
                                require("../assets/images/galleries/metro13/8.jpg"),
                                require("../assets/images/galleries/metro13/9.jpg"),]
            },
                
               
                
            
                
        ],
        index: null,
        saveIndex: 0,
        }
    },
    methods:{
      // 1
      getIndex(imageIndex, galleryIndex){
        // this.saveIndex = this.saveIndex + imageIndex + 1; 
        // var x = this.saveIndex + imageIndex + 1
        // this.saveIndex = x;
        if(galleryIndex == 0){
            return imageIndex
        }
        let sum = 0;
        for(let i = 0; i < galleryIndex; i++){
            sum += this.galleryLength[galleryIndex -1];
        }
        console.log(sum + imageIndex);   
        return sum + imageIndex
        // return galleryIndex == 0 ? imageIndex : this.saveIndex
        // return imageIndex;
      },
    },
    computed:{
        images(){
            var arr =[]
            this.galleries.forEach(gallery => {
                gallery.images.forEach(image => arr.push(image))
            })
            return arr;
        },
        galleryLength(){
            return this.galleries.map(gallery => gallery.images.length)
        }
    }
}
</script>

<style scoped>
.gallery-wrapper{
    margin: 10px auto;
    /* width:93%;
    margin: 0 auto; */
}
  .image {
    display: inline-block;
    /* background-size: cover;
    background-repeat: no-repeat;
    background-position: center center; */
    border: 1px solid #ebebeb;
    /* margin-right: 1px;
    margin-left: 1px; */
    width:33.3%;
    height: 280px;
    /* max-height: 250px; */
    flex: 1;
  }

  .image > span > img{
      object-fit: cover;
      object-position: center;
  }

  .gallery-hero{
    position: relative;
    background-image: linear-gradient(120deg, #16161588 0%, #f7f7f700 100%), url('../assets/images/12.jpg');
    /* background-blend-mode: screen; */
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 45vh;
  }

  .hero-heading{
    font-size:108px; font-weight:700; font-family: Raleway;color: #f5f7f9; margin-bottom:-26px;letter-spacing:1rem;
}

  .years{
      font-size: 3rem;
      
  }

  @media (max-width: 768px){
.gallery-hero{
    height: 30vh;
    }
.hero-heading{
    font-size:6rem; font-weight:700; font-family: Raleway;color: #f5f7f9; margin-bottom:-15px;letter-spacing:.5rem;
    }
    /* .gallery-wrapper{
    
    margin: 0 auto;
}
    .image{
        width:40%
    }
    .image img{
        height:15rem !important;
        width:15rem !important;
    } */
    .image{
         display: inline-block;
        flex:1; 
        width:50%;
        height:auto;
    }
}
</style>